// ------------------------------------
// Inicializa os Contadores
// ------------------------------------

// Inicia o contador
$(function () {
  initCountdowns();
});

function initCountdowns() {
  $('.countdown').each(function () {
    initCountdown($(this));
  });
}

function initCountdown($el) {
  const $countdownEl = $el;
  if ($countdownEl.length > 0) {
    const mode = $countdownEl.data('mode');
    const minutes = $countdownEl.data('minutes');
    const date = $countdownEl.data('date');
    let futureDate;
    if (mode === 'date') {
      futureDate = new Date(date);
    } else if (mode === 'minutes') {
      futureDate = new Date();
      futureDate.setMinutes(new Date().getMinutes() + Number(minutes));
    }
    if ($countdownEl[0]._countdown) {
      $countdownEl[0]._countdown.destroy();
    }
    $countdownEl[0]._countdown = new Countdown(futureDate, $countdownEl);
  }
}

// Classe do cronômetro
class Countdown {
  constructor(futureDate, $el = false) {
    this.futureDate = futureDate;
    if ($el && $el.length > 0) {
      this.ele = $el;
      this.daysEle = $el.find('[data-cd="days"]');
      this.hoursEle = $el.find('[data-cd="hours"]');
      this.minutesEle = $el.find('[data-cd="minutes"]');
      this.secondsEle = $el.find('[data-cd="seconds"]');
    } else {
      this.daysEle = $('[data-cd="days"]');
      this.hoursEle = $('[data-cd="hours"]');
      this.minutesEle = $('[data-cd="minutes"]');
      this.secondsEle = $('[data-cd="seconds"]');
    }
    this.init();
  }
  init() {
    this.timer = setInterval(() => {
      this.counter();
    }, 1000);
  }
  counter() {
    const currentDate = new Date();
    this.diff = this.futureDate.getTime() - currentDate.getTime();
    const days = this.getDays();
    const hours = this.getHours();
    const minutes = this.getMinutes();
    const seconds = this.getSeconds();
    if (this.daysEle) {
      this.daysEle.text(days);
      if (this.ele) {
        if (Number(days) < 1) {
          this.ele.find('.cd-days').hide();
        } else {
          this.ele.find('.cd-days').show();
        }
      } else {
        if (Number(days) < 1) {
          $('.cd-days').hide();
        } else {
          $('.cd-days').show();
        }
      }
    }
    if (this.hoursEle) {
      this.hoursEle.text(hours);
      if (this.ele) {
        if (Number(hours) < 1) {
          this.ele.find('.cd-hours').hide();
        } else {
          this.ele.find('.cd-hours').show();
        }
      } else {
        if (Number(hours) < 1) {
          $('.cd-hours').hide();
        } else {
          $('.cd-hours').show();
        }
      }
    }
    if (this.minutesEle) {
      this.minutesEle.text(minutes);
    }
    if (this.secondsEle) {
      this.secondsEle.text(seconds);
    }
    if (this.diff < 1000) {
      this.destroy();
    }
  }
  getDays() {
    const days = Math.floor(this.diff / 1000 / 60 / 60 / 24);
    return days >= 0 ? days : 0;
  }
  getHours() {
    return this.zeroFill(Math.floor(this.diff / 1000 / 60 / 60) % 24);
  }
  getMinutes() {
    return this.zeroFill(Math.floor(this.diff / 1000 / 60) % 60);
  }
  getSeconds() {
    return this.zeroFill(Math.floor(this.diff / 1000) % 60);
  }
  zeroFill(num) {
    let n = num < 0 ? 0 : num;
    return n > 9 ? n : '0' + n;
  }
  updateDate(date) {
    clearInterval(this.timer);
    this.futureDate = new Date(date + ' GMT-0300');
    this.init();
  }
  destroy() {
    clearInterval(this.timer);
  }
}
